export default __webpack_public_path__ + "static/media/sc-bc-active-ico.3384900d.svg";